import { Link } from '@nimbus-ds/components';
import { InvoiceItemInterface } from '@tiendanube/common';
import { DataList } from '@tiendanube/components';
import Text from 'commons/components/LegacyText';
import Stack from 'commons/components/Stack';
import { useTranslationBilling } from 'domains/Billing';
import useDownloadInvoice from 'domains/Billing/Invoices/pages/InvoicesListPage/components/InvoiceHistory/useDownloadInvoice';

const { Cell } = DataList;

interface DataTableRowProps {
  month: string | false;
  invoiceType: string;
  invoiceItem: string;
  period: string;
  invoice: InvoiceItemInterface;
}

function LeftCell({
  month,
  invoiceItem,
  invoiceType,
  period,
  invoice: { isCreditNote, isFromBillingEngine, associatedInvoiceId },
}: DataTableRowProps): JSX.Element {
  const t = useTranslationBilling();
  const shouldLetDownloadCancelledInvoice =
    isFromBillingEngine &&
    isCreditNote &&
    associatedInvoiceId &&
    invoiceType.includes('#');

  const { getLinkForBillingEngine } = useDownloadInvoice();

  const typeText = shouldLetDownloadCancelledInvoice ? (
    <Text bold>
      {invoiceType.split('#')[0]}
      <Link
        as="span"
        appearance="primary"
        onClick={() => getLinkForBillingEngine(associatedInvoiceId)}
      >{`#${invoiceType.split('#')[1]}`}</Link>
    </Text>
  ) : (
    <Text bold>{invoiceType}</Text>
  );

  return (
    <Cell>
      <Stack column align="flex-start">
        {!!month && (
          <Text appearance="secondary" bold>
            {month}
          </Text>
        )}
        <Stack column align="flex-start" spacing="tight">
          {typeText}
          <Stack column spacing="none" align="flex-start">
            <Text>{invoiceItem}</Text>
            <Text appearance="light">{`${t(
              'invoiceHistory.period',
            )}: ${period}`}</Text>
          </Stack>
        </Stack>
      </Stack>
    </Cell>
  );
}

export default LeftCell;
